import { Component, OnInit, Input } from '@angular/core';
import { ProjectParticipant } from '../../../project-misc/data/project/project-participant';
import { ProjectService } from '../../../project-misc/data/project/project.service';
import { ProjectHolder } from '../../../project-misc/interfaces/project-holder';
import { Project } from '../../../project-misc/data/project/project';

@Component({
    selector: 'app-user-info-popup',
    templateUrl: './user-info-popup.component.html',
    styleUrls: ['./user-info-popup.component.scss']
})
export class UserInfoPopupComponent implements OnInit {
    @Input()
    participant: ProjectParticipant

    projectId: number

    project: Project;

    constructor(
        protected projectHolder: ProjectHolder,
        protected projectService: ProjectService
    ) {
        this.project = this.projectHolder.project
    }

    ngOnInit() {
        this.projectId = this.projectHolder.project.id
    }

    removeUser() {
        this.projectService
            .detachUser(this.projectId, this.participant.user.id)
            .subscribe(project => {
                this.project.participants = project.participants
            })
    }

}
